/**
 * @file timeformat
 * @author yuanhuihui  2017/8/4
 */

module.exports = function (_value, _fmt) {
    let date = _value
    let fmt = _fmt
    let k, o
    date = date instanceof Date ? date : new Date(date)
    o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (String(date.getFullYear())).substr(4 - RegExp.$1.length))
    }
    for (k in o) {
        if (o.hasOwnProperty(k) && new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr((String(o[k]).length))))
        }
    }
    return fmt
}



// WEBPACK FOOTER //
// ./src/filters/timeformat.js